import { render, staticRenderFns } from "./rebuttalTraining.vue?vue&type=template&id=00226c0e&scoped=true&"
import script from "./rebuttalTraining.vue?vue&type=script&lang=js&"
export * from "./rebuttalTraining.vue?vue&type=script&lang=js&"
import style0 from "./rebuttalTraining.vue?vue&type=style&index=0&id=00226c0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00226c0e",
  null
  
)

export default component.exports